import { Navigate, Outlet, useLocation } from "react-router-dom";
import { USER_TYPES, useUserStore } from "@/service/user";
import { ROUTES } from "@/shared/constants";
import { Loader } from "@/shared/ui";

interface PrivateRouteProps {
  userType?: "employee" | "admin";
}

const PrivateRoute = ({ userType }: PrivateRouteProps) => {
  const { user, inited } = useUserStore();
  const location = useLocation();

  if (!inited)
    return (
      <>
        <Loader fullPage />
        <Outlet />
      </>
    );

  if (!user) {
    return <Navigate to={ROUTES.LOGIN} replace state={{ from: `${location.pathname}${location.search}` }} />;
  }

  if (userType && user.type !== userType && user.type !== USER_TYPES.ADMIN) {
    return <Navigate to={ROUTES.LOGIN} replace />;
  }

  return <Outlet />;
};

export default PrivateRoute;
